import React from 'react'
import useSelector from 'hooks/use-selector'
import logUtil from 'utils/log'
import useDispatch from 'hooks/use-dispatch'
import getAmountGiftSelect from 'modules/gift/redux/selectors/get-amount'
import { GIFT_CARD_AMOUNT_TO_VARIANT_ID } from 'modules/gift/constants'
import getSelectedVariantSelect from 'modules/variant/redux/selectors/get-selected-variant'
import isSelectedVariantOutOfStockVariantSelect from 'modules/variant/redux/selectors/is-selected-variant-out-of-stock'
import suggestOtherColorProductAction from 'modules/product/redux/actions/suggest-other-color'
import runAfterDelayTimingUtil from 'utils/timing/run-after-delay'
import getVariantIdFromUrlProductUtil from 'modules/product/utils/get-variant-id-from-url'
import logEventAnalyticsUtil from 'utils/analytics/log-event'

const ANALYTICS_EVENT = {
  QUICK_SHOP_SUGGEST_IN_STOCK_VARIANT_ON_MOUNT: 'QUICK_SHOP_SUGGEST_IN_STOCK_VARIANT_ON_MOUNT'
}

/**
 * @param props
 * @param props.isGiftCard
 * @returns {JSX.Element}
 * @constructor
 */
export default function QuickShopProductSidebarSuggestInStockVariantOnMount (props) {
  const dispatch = useDispatch()
  const selectedVariant = useSelector(getSelectedVariantSelect)
  const isOutOfStock = useSelector(
    isSelectedVariantOutOfStockVariantSelect
  )
  const hasSelectedVariant = !!selectedVariant
  const variantIdUrl = getVariantIdFromUrlProductUtil()
  const variantIdState = (
    selectedVariant?.variant_id
  )
  const isGiftCard = props.isGiftCard
  const amount = useSelector(getAmountGiftSelect)
  const variantId = isGiftCard
    ? GIFT_CARD_AMOUNT_TO_VARIANT_ID[amount]
    : variantIdState

  const setIsLoading = props.setIsLoading

  const debugProps = {
    selectedVariant,
    hasSelectedVariant,
    variantIdUrl,
    isOutOfStock,
    variantId
  }
  logUtil('QuickShopProductSidebarSuggestInStockVariantOnMount').debug('debugProps=', debugProps)

  const handleOutOfStockOnMount = async () => {
    if (!hasSelectedVariant) {
      logUtil('QuickShopProductSidebarSuggestInStockVariantOnMount').debug('[noop] no hasSelectedVariant')
      setIsLoading(false)
      return
    }

    if (!isOutOfStock) {
      logUtil('QuickShopProductSidebarSuggestInStockVariantOnMount').debug('[noop] not out of stock')
      setIsLoading(false)
      return
    }

    if (!variantId) {
      logUtil('QuickShopProductSidebarSuggestInStockVariantOnMount').debug('[noop] no variantId')
      setIsLoading(false)
      return
    }

    if (
      variantIdUrl &&
      Number(variantIdUrl) !== variantId
    ) {
      logUtil('QuickShopProductSidebarSuggestInStockVariantOnMount').debug('[noop] variantIdUrl is not the same as variantId')
      setIsLoading(false)
      return
    }

    logEventAnalyticsUtil(ANALYTICS_EVENT.QUICK_SHOP_SUGGEST_IN_STOCK_VARIANT_ON_MOUNT)
    await runAfterDelayTimingUtil(300)
    dispatch(
      suggestOtherColorProductAction({
        justAddedVariantId: variantId,
        shouldAddToUrl: false
      })
    )
    setIsLoading(false)
  }

  React.useEffect(() => {
    handleOutOfStockOnMount()
  }, [hasSelectedVariant])

  return <></>
}
